import type { IconSvgObject } from './types';

const Upload02Icon: IconSvgObject = [
  ["path", { d: "M7 9L12 3L17 9H14L14 17.5H10L10 9H7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.00006 21H19.0001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Upload02Icon;
